// extracted by mini-css-extract-plugin
module.exports = {"banner-qr-box":"a","bannerQrBox":"a","qr-img-box":"b","qrImgBox":"b","qr-img-text":"c","qrImgText":"c"};